

export default class SuccessRelativePercentages {
  constructor (successByPredictionConfig) {
    //Get all
    this.map = {}
    for (var i = 0 ;i < successByPredictionConfig.tagVersions.length; i++) {
      var tagVersion = successByPredictionConfig.tagVersions[i]
      this.map[tagVersion] = {}
      var averages = successByPredictionConfig.configList.map(obj => {
        if (obj.tagVersions[tagVersion]) {
          return average(obj.tagVersions[tagVersion].winPercentage)
        }else {
          return 0
        }
      }).filter(a => a !== 0).sort((a,b) => b - a)
      var diff = averages[0] - averages[averages.length -1]
      for (var a = 0; a < averages.length; a++) {
        this.map[tagVersion][averages[a]] = 1 - ((averages[0] - averages[a]) / diff)
      }
    }
  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}
